if (!customElements.get('variant-label')) {
  class VariantLabel extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      // 在 init 时查询子节点：constructor 阶段子节点可能尚未就绪，避免 NodeList 为空导致从不切换 hidden。
      this.variantLabels = this.querySelectorAll('.js-variant-label');
      if (!this.variantLabels.length) return;

      this._productRoot = this.closest('.js-product') || this.closest('.product');
      // 注意：sticky 弹窗会把 variant-picker 节点移动到商品根节点之外，
      // 此时事件冒泡不到 _productRoot。改为监听 document，并通过 evt.detail.form 过滤归属商品。
      this._onVariantChange = this.handleVariantChange.bind(this);
      document.addEventListener('on:variant:change', this._onVariantChange);

      if (this.dataset.currentVariantId) {
        this.setVisibleVariantLabel(this.dataset.currentVariantId);
      }
    }

    disconnectedCallback() {
      if (this._onVariantChange) document.removeEventListener('on:variant:change', this._onVariantChange);
    }

    /**
     * @param {string|number} variantId
     */
    setVisibleVariantLabel(variantId) {
      if (!this.variantLabels || !this.variantLabels.length) {
        this.variantLabels = this.querySelectorAll('.js-variant-label');
      }
      if (variantId == null || variantId === '') return;

      var idStr = String(variantId);
      this.variantLabels.forEach(function (variantLabel) {
        var match =
          variantLabel.dataset.variantId != null &&
          String(variantLabel.dataset.variantId) === idStr;
        if (match) {
          variantLabel.removeAttribute('hidden');
          variantLabel.hidden = false;
        } else {
          variantLabel.setAttribute('hidden', '');
          variantLabel.hidden = true;
        }
      });
    }

    handleVariantChange(evt) {
      if (!evt.detail || !evt.detail.variant) return;
      if (this._productRoot && evt.detail.form && !this._productRoot.contains(evt.detail.form)) return;
      var id = evt.detail.variant.id;
      if (id == null) return;
      this.setVisibleVariantLabel(id);
    }
  }

  customElements.define('variant-label', VariantLabel);
}
